export type PrivateCommentSlashCopy = {
  title: string;
  subtext: string;
  aliases: string[];
};

export function privateCommentSlashCopy(
  isPrivate: boolean
): PrivateCommentSlashCopy {
  if (isPrivate) {
    return {
      title: 'Set visible to all project users',
      subtext: 'Clients can see this',
      aliases: [
        'public',
        'all users',
        'everyone',
        'visible',
        'guest',
        'client',
        'open'
      ]
    };
  }

  return {
    title: 'Set to members only comment',
    subtext: 'Visible to internal team only',
    aliases: [
      'member',
      'members',
      'private',
      'internal',
      'private comment',
      'internal comment',
      'member comment',
      'members only'
    ]
  };
}

export type ApplyPrivateCommentSlashArgs = {
  isPrivate: boolean;
  canCreatePrivate: boolean;
  hasInvalidMentions: boolean;
  onToggle: (checked: boolean) => void;
  onUpgrade?: () => void;
};

export function applyPrivateCommentSlashSelect({
  isPrivate,
  canCreatePrivate,
  hasInvalidMentions,
  onToggle,
  onUpgrade
}: ApplyPrivateCommentSlashArgs): void {
  if (!canCreatePrivate) {
    onUpgrade?.();
    return;
  }

  const nextPrivate = !isPrivate;
  if (nextPrivate && hasInvalidMentions) return;
  onToggle(nextPrivate);
}
